import React from 'react'
import styles from './LeftSidebar.module.css'

const LeftSidebar = ({ activeTab, setActiveTab }) => {
    const menuItems = [
        { id: 'shortlist', label: 'Shortlist', icon: '📋' },
        { id: 'actions', label: 'Actions', icon: '✓' },
    ]

    return (
        <div className={styles.sidebar}>
            {menuItems.map((item) => (
                <button
                    key={item.id}
                    className={`${styles.menuItem} ${activeTab === item.id ? styles.active : ''}`}
                    onClick={() => setActiveTab(item.id)}
                >
                    <span className={styles.icon}>{item.icon}</span>
                    <span className={styles.label}>{item.label}</span>
                </button>
            ))}
        </div>
    )
}

export default LeftSidebar
